module EEX.McEc {

    export module Apps {
        import CertificateModel = McEc.Domain.CertificateModel;

        export class DashboardApp extends AppKitchen.AppBase<AppKitchen.AppBaseOptions> {

            private containers: {
                certificatePie: HTMLElement,
                serverCertificatePie: HTMLElement,
            }

            private buttons: {
                certificate: JQuery,
                serverCertificate: JQuery,
            }

            private chartModelCertificates: AppKitchen.Controls.Charts.PieChartModel;
            private chartModelServerCertificates: AppKitchen.Controls.Charts.PieChartModel;

            public start() {
                AppKitchen.UIHelper.renderTemplateTo(this.el, McEc.Templates.Dashboard);

                this.containers = {
                    certificatePie: this.$el.find(".certificate-list-statistics-tile > .eex-mcec-tile-content")[0],
                    serverCertificatePie: this.$el.find(".server-certificate-list-statistics-tile > .eex-mcec-tile-content")[0],
                }

                this.buttons = {
                    certificate: this.$el.find(".certificate-list-statistics-tile"),
                    serverCertificate: this.$el.find(".server-certificate-list-statistics-tile"),
                }

                this.setButtonAction();

                this.chartModelCertificates = this.createPieChart(this.containers.certificatePie);
                this.chartModelServerCertificates = this.createPieChart(this.containers.serverCertificatePie);

                this.loadPieChartDataCertificates(this.chartModelCertificates);
                this.loadPieChartDataServerCertificates(this.chartModelServerCertificates);
            }

            private setButtonAction() {
                this.buttons.certificate.click(() => {
                    this.goToRoute("Certificates");
                });

                this.buttons.serverCertificate.click(() => {
                    this.goToRoute("ServerCertificates");
                });
            }

            private goToRoute(route: string) {
                AppKitchen.BrowserHelper.setUrl(`#/${route}/`);
            }

            private createPieChart(target: HTMLElement) {
                let chartModel = new AppKitchen.Controls.Charts.PieChartModel();

                // ReSharper disable once WrongExpressionStatement
                new AppKitchen.Controls.Charts.PieChartView(chartModel,
                    target,
                    {
                        noDataMessage: Strings.Chart_NoVersionData,
                        legend: {
                            align: "left",
                            labels: {
                                //color: "#000000",
                                font: "15px",
                                template: this.renderLegendLabel
                            }
                        },
                        seriesDefaults: {
                            labels: {
                                visible: false,
                                background: "transparent",
                                template: "#= category #: \n #= value#"
                            }
                        }
                    });
                return chartModel;
            }

            private renderLegendLabel(l: any): string {
                return `${l.dataItem.category} (${l.dataItem.value})`;
            }

            private loadPieChartDataCertificates(chartModel: AppKitchen.Controls.Charts.PieChartModel) {
                new McEc.Data.Provider.CertificatesProvider().load()
                    .then(certificates => chartModel.data(this.convertToPieData(certificates)))
                    .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
            }

            private loadPieChartDataServerCertificates(chartModel: AppKitchen.Controls.Charts.PieChartModel) {
                new McEc.Data.Provider.ServerCertificatesProvider().load()
                    .then(certificates => chartModel.data(this.convertToPieData(certificates)))
                    .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
            }

            private convertToPieData(certificates: CertificateModel[]): AppKitchen.Controls.Charts.PieChartDataItem[] {
                let grouped = certificates.AsLinq<CertificateModel>().Select(c => c.State).GroupBy(s => s);
                return grouped.Select(McEc.Helper.convertPieData).ToArray();
            }
        }
    }
}